<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I would like to thank my wonderful Angela, son, Sean, family and friends – Terry, Teresa H, Vanessa and Anthony – who had more faith in me than I did myself and without whom I would never have finished <em>Tears of Gold</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7d9297e6